<template>
  <div class="w-100 px-5 py-4">
    <div slot="title">
      <h1>REPRODUCTOR DE AUDIENCIAS</h1>
      <h3>{{Audiencia.TipoDocumento.Nombre}} {{Audiencia.Consecutivo}} </h3>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="area">
          <h2 v-on:click="mostrarInfo = !mostrarInfo">Información</h2>
          <hr />
          <div class="row col-12" style="display: flex; padding:0" id="info_div" v-if="mostrarInfo">
            <div class="col-4"><strong>Juzgado: </strong><br />{{Audiencia.Area.Nombre}}</div>
            <div class="col-2"><strong>Materia: </strong><br />{{Audiencia.Materia.Nombre}}</div>
            <div class="col-2"><strong>Tipo de documento: </strong><br />{{Audiencia.TipoDocumento.Nombre}}</div>
            <div class="col-2"><strong>Consecutivo: </strong><br />{{Audiencia.Consecutivo}}</div>
            <div class="col-4">
              <strong>Jueces: </strong><br />
              <p v-for="(Juez,index) in Audiencia.JuecesEnAudiencia">{{index + 1}}.- {{Juez.Juez.Nombre}} {{Juez.Juez.ApellidoPaterno}} {{Juez.Juez.ApellidoMaterno}}</p>
            </div>
            <div class="col-2"><strong>Tipo de audiencia: </strong><br />{{Audiencia.TipoAudiencia.Nombre}}</div>
            <div class="col-2"><strong>Fecha y Hora: </strong><br />{{Audiencia.FechaAudiencia | fechaHora }}</div><br />
            <div class="col-2"><strong>Sala: </strong><br />{{Audiencia.Sala.Nombre}}</div>
            <div class="col-2"><strong>Estatus de la audiencia: </strong><br />{{Audiencia.TipoEstatusDeAudiencia.Nombre}}</div>
            <div class="col-12">
              <strong>Sesiones de la audiencia: </strong><br /><br />              
              <div id="sesiones_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">Sala</th>
                      <th class="text-left">Fecha de inicio</th>
                      <th class="text-left">Fecha de finalización</th>
                    </tr>
                  </thead>
                  <tbody v-for="(Sesion, index) in Audiencia.SesionesDeLasAudiencias" class="text-dark">
                    <tr>
                      <td><input type="radio" @click="cambiarSesion(Sesion)" name="sesionSelect" /></td>
                      <td>{{Sesion.Sala.Nombre}}</td>
                      <td>{{Sesion.FechaDeInicio | fechaHora}}</td>
                      <td>{{Sesion.FechaDeFinalizacion | fechaHora}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="DespliegueVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" v-if="IdSessionSeleccionada != null">
        <div class="area marcadores" v-if="Audiencia != null">
          <div>
            <h5>Marcadores</h5>
            <hr />
            <ul class="form-group list-group">
              <li v-for="marcador in Sesion.Marcadores" class="list-group-item" @click="cargarEnVideo(marcador)">
                <h6>{{marcador.Tiempo}}</h6>
                <span>{{marcador.TipoMarcador.Nombre}}<br v-if="marcador.TipoMarcador.TipoMarcadorId == 94" />{{marcador.TipoMarcador.TipoMarcadorId == 94 ? marcador.DuracionDelReceso : ""}}</span>
                <br />
                <span v-if="marcador.TipoMarcador.TipoMarcadorId == 99 || marcador.TipoMarcador.TipoMarcadorId == 94">Observaciones: {{marcador.Comentarios}}</span>
                <br />
                <span v-if="marcador.Evidencias.length > 0">Evidencias:</span>
                <div v-if="marcador.Evidencias.length > 0" class="evidencias">
                  <ul class="form-group list-group">
                    <li v-for="(evidencia, index) in marcador.Evidencias">
                      <span>{{index + 1 }}.-</span>
                      <span>{{evidencia.TipoEvidencia.Nombre}}</span><br />
                      <span>{{evidencia.Titulo}}</span><br />
                      <span>{{evidencia.Descripcion}}</span><br />
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" v-if="IdSessionSeleccionada != null">
        <div class="area" v-if="Audiencia != null">
          <Reproductor  :componentesDeCamaras="componentesDeCamaras" :reproducirVideo="true" :parametros="Sesion" :key="Audiencia.AudienciaId"></Reproductor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas';
  import api from '@/../static/js/api'
  import axios from 'axios'
  import moment from 'moment';

  export default {
    components: {
      Reproductor: sistemas.Forseti.Reproductor
    },
    data() {
      return {
        componentesDeCamaras: [
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.Comenzar },
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.Reproducir },
          { componenteDeCamaraId: enumeraciones.componentesDeCamaras.LineaDeTiempo }
        ],
        camaras: [
          { camaraId: enumeraciones.camaras.Juez },
          { camaraId: enumeraciones.camaras.Imputado },
          { camaraId: enumeraciones.camaras.Victima },
          { camaraId: enumeraciones.camaras.Testigos },
          { camaraId: enumeraciones.camaras.Protegido },
          { camaraId: enumeraciones.camaras.Publico },
          { camaraId: enumeraciones.camaras.Evidencias }
        ],
        mostrarInfo: true,
        Audiencia: {
          Area: { Nombre: String },
          Materia: { Nombre: String },
          TipoAudiencia: {
            Nombre: String
          },
          TipoDocumento: {
            Nombre: String
          },
          Fecha: String,
          HoraDeInicio: String,
          HoraFinalizada: String,
          Jueces: [
            { Nombre: String }
          ],
          Sala: { Nombre: String },
          TipoEstatusDeAudiencia: {
            TipoEstatusDeAudienciaId: Number,
            Nombre: String
          },
          Marcadores: []
        },
        Sesion: {
          SesionDeLaAudienciaId: null,
          Sala: { Nombre: String },
          Marcadores: []
        },
        IdSessionSeleccionada : null
      }
    },
    props: {
      AudienciaId: Number
    },
    filters: {
      fechaHora(fecha) {
        return moment(String(fecha)).format('DD/MM/YYYY hh:mm');
      }
    },
    mounted() {
      this.busquedaAudiencia();
    },
    methods: {
      cambiarSesion: function (sesion) {       
        this.Sesion = sesion;
        this.IdSessionSeleccionada=null;
        setTimeout(()=>{
          this.IdSessionSeleccionada = this.Sesion.SesionDeLaAudienciaId
        }, 200)
        
      },
      cargarEnVideo: function (marcador) {
        let tiempo = marcador.Tiempo;

        this.Sesion.RutasDeVideos.forEach((element) => {
          const videoCamara = document.getElementById("camara" + element.Camara.CamaraId);
          if (!videoCamara)
            return

          var seconds = (+tiempo.split(':')[0]) * 60 * 60 + (+tiempo.split(':')[1]) * 60 + (+tiempo.split(':')[2]);

          videoCamara.currentTime = parseInt(seconds);
        });
      },
      async busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }

        axios.post(api.conexion + api.Forseti.sistema.consultas.audienciasFinalizadas.GetAudienciaFinalizada,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(async respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            //CargarDatos de audiencia
            this.Audiencia = respuesta.data.AudienciaFinalizada;          
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .botones {
    width: 230px;
    height: 53px;
    overflow-x: auto;
    white-space: nowrap;
  }

  .marcadores {
    height: 600px;
  }

    .marcadores ul {
      overflow-y: auto;
      height: 500px;
    }

      .marcadores ul li {
        background-color: #504f54;
        border: 1px solid rgba(0,0,0,.125);
      }

  .evidencias {
    max-height: 150px;
  }

    .evidencias ul {
      overflow-y: auto;
      max-height: 115px;
    }

      .evidencias ul li {
        border: 0px solid rgba(0,0,0,.125);
      }

  /*.evidencias ul li {
        background-color: #656369;
        border: 1px solid rgba(0,0,0,.125);
      }*/
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Consultas/PanelDeAudienciasFinalizadas/ReproductorDeAudiencias.vue